import { TableCell, TableCellProps } from '@mui/material';

export const CenteredTableCell = (props: TableCellProps) => {
  return <TableCell align="center" {...props} />;
};
